<template>
<div id='app'> 
<b-modal id="modal-sm" size="md" title="Patient Notes" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
    <div slot="default">
        <div class='alert alert-warning' role='alert'>  Patient not found </div>
        
    </div> 
    <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button variant="primary"  size="md"  class="float-right"  @click="PatientExit"> Close </b-button>
    </div>
</b-modal> 
<b-modal id="editModal"  v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
    ok-variant cancel-variant hide-footer
      header-class="PopUpHeader" 
    :header-text-variant=PopUpVar.headerTextVariant
    :body-bg-variant=PopUpVar.bodyBgVariant
    :body-text-variant=PopUpVar.bodyTextVariant
    :footer-bg-variant=PopUpVar.footerBgVariant
    :footer-text-variant=PopUpVar.footerTextVariant> 
    <PatientNoteAddEdit v-if="showEditModal==true" :UserData="UserData" :mode="Button" @PatientNoteExit="closeModal"></PatientNoteAddEdit>
    <template slot="modal-header"> 
      <div>
      <small class="PopUpTitle w-100 text-left">{{Button}} Note</small>
    </div> 
    <div v-show="Access=='Edit'"><small class="modal-title w-100 text-right"></small></div>
  </template> 
    
</b-modal> 

<Subtitle  v-bind:ServiceID="this.NoteType">
  <template v-slot:header>
  <i class="fas fa-notes-medical"></i><b>Patient Notes:</b>
</template> 
</Subtitle>

<form class="card  p-0 mb-1" id="SearchForm">
  <div class="card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
        <h5><small class="text-muted"><b><i class="fas fa-search-plus"></i>Search: HSN required</b></small></h5>
  </div>
  <div class="form-row p-1">
    <div class="form-group col-sm-4">
      <label for="inputEmail4" class="label-small">HSN</label>
        <input id="UserID" @input="disableSearch" v-model="HSN" maxlength="9" placeholder="HSN" class="form-control form-control-sm">
       <div class="row" v-show="$v.HSN.$error">           
     <div class="col-sm-12">
          <small class="sml-red" v-if="!$v.HSN.required">HSN is required.</small>
            <small class="sml-red" v-if="!$v.HSN.numeric">HSN must be a number.</small>
      </div> 
      </div>
    </div> 
    <div class="form-group col-sm-4">
      <label for="inputPassword4" class="label-small">  </label>
      <div class="mt-1">
         <button v-on:click="GetHsnInfo"  type="button" class="btn btn-primary btn-sml">  Search  </button>
      </div>
    </div> 
  </div> 
</form> 
<!-- <h4><small class="text-muted"><i class="fas fa-notes-medical"></i><b>Patient Notes:</b></small></h4>   -->
 <div  class="row no-gutters mb-3"> 
  <div class="col-4 pr-1" v-if="Patient != null && isValid">
          <div class="card">
        <div class="card-header   d-flex align-items-center  pl-1" style="height: 2rem; text-align:left;">
        <h5><small class="text-muted"><b><i class="fas fa-user-injured"></i>Patient:  {{Patient.firstName}} , {{Patient.lastName}} </b></small></h5>
        </div>
          <div  class="card-body p-2" >
                <div class="row" >
                  <span for="cname" class="col-sm-4"><b>HSN:</b></span> 
                  <span   class="col-sm-8" type="text">{{HSN}}</span> 
                </div>
        
                <div class="row">
                  <span for="cname" class="col-sm-4"><b>Address:</b></span> 
                  <span class="col-sm-8" type="text">{{Patient.address1}}</span> 
                </div>
                <div class="row">
                  <span for="cname" class="col-sm-4"><b>DOB:</b></span> 
                  <span class="col-sm-8" type="text">{{Patient.birthDay |moment(Patient.birthDay ) }} </span> 
                </div>
                <div class="row">
                  <span for="cname" class="col-sm-4"><b>City:</b></span> 
                  <span class="col-sm-8" type="text">{{Patient.address2}}</span> 
                </div>
          </div>
    </div>
  </div>
</div> 
<v-client-table v-if="isValid" :columns="columns" :data="tableData" :options="options">
        <span class="pointer" v-on:click="EditPatientNotePopup(props.row)" slot="edit" slot-scope="props" ><i class="fa fa-pencil-alt" ></i></span>
        <div   v-if="AllowAdd" slot="beforeFilter"  class="VueTables_Adduser">
            <label for="VueTables_Adduser" class="VueTables_user"> Add Note: </label>
            <button :disabled="!isValid" type="button"  v-on:click="AddPatientNotePopup" class="btn btn-primary form-control mr-2 ">Add Note</button>
        </div>
</v-client-table>   
</div>
</template>

<script>
import Vue from 'vue'; 
import Card from "@/Common/Card.vue";
import Subtitle from '@/Common/Default/SubTitle.vue';  
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import moment from 'moment'
import PatientNoteAddEdit from '@/components/DPEBB/Administrator/PatientNoteAddEdit.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import axios from 'axios';
import Vuelidate from 'vuelidate'
import {helpers, required, minLength, sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
Vue.use(Vuelidate);
export default {
    props:{
      Mode:'',
      Type:''
    },
     data: function(){
        return {
            Patient:null,
            AppName: 'Dental Application',
            AppIcon: 'fas fa-tooth',
            HSN:'',
            showModal:false,
            isValid:false,
            Access:'',
            NoteType:'',
            AllowAdd:false,
            showEditModal:false,
            PopUpVar:PopUpVariant,
            Button:'',
        columns: ['edit' , 'hsn','name','notes','createddate','createdby',
        'updateddate', 'lastUpdatedby'],
        tableData: [],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Name',
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns',
              noResults:"No Patient Notes records Found",
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['effectivedate','expirydate'],
          toMomentFormat: 'YYYY-MM-DD',
         
          templates: {
            createddate(h, row){
              return moment(row.createddate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            updateddate(h, row) {
              return moment(row.updateddate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            }
            },

          headings: {
            edit: '',
            hsn: 'HSN',
            name: 'Service Type',
            notes: 'Notes',
            createddate: 'Note Date',
            createdby: 'Created By',
            updateddate: 'Updated Date',
            lastUpdatedby: 'Update By',

           
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['hsn','name','notes','createddate','createdby', 'updateddate', 'lastUpdatedby'],
         filterable: ['hsn','name','notes','createddate','createdby', 'updateddate', 'lastUpdatedby'], 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
            }       
        }
        },
        components: {

          Modal:Modal,
          Card,
          CardBody,
          TileNote,
          PatientNoteAddEdit,
          Subtitle
    },
     filters: {
          moment: function (date) {
          return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          }
     },
    created: function(){
      this.Access = this.Mode;
      this.NoteType = this.Type;
      if(this.Access == 'Add' || this.Access == 'Edit')
        this.AllowAdd = true;
      if(this.NoteType == '1')
      {
        this.AppName = 'Dental Application';
        this.AppIcon = 'fas fa-tooth';
      }
      else  if(this.NoteType == '1')
      {
        this.AppName = 'Dental Application';
        this.AppIcon = 'fas fa-tooth';
      }
      else  if(this.NoteType == '2')
      {
        this.AppName = 'Medical Application';
        this.AppIcon = 'fas fa-hospital-alt';
      }
      else  if(this.NoteType == '3')
      {
        this.AppName = 'Optical Application';
        this.AppIcon = 'fas  fa-glasses';
      }
      else  if(this.NoteType == '4')
      {
        this.AppName = 'Hearing Application';
        this.AppIcon = 'fas fa-assistive-listening-systems';
      }
      else  if(this.NoteType == '5')
      {
        this.AppName = 'Podiatry Application';
        this.AppIcon = 'fas  fa-shoe-prints';
      }
      else  if(this.NoteType == 'DPEBB')
      {
        this.AppName = 'DPEBB Application';
        this.AppIcon = 'fas fa-file-prescription';
      }

    },
    mounted:function(){
       if (this.Access!="Edit"){
           this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
       }
    },
    computed:{
        UserName(){
            return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        },
   AllAppLevel(){
            return this.$store.getters.GetAllApplevel;
          } 
    },

    validations(){
      return { 
        HSN :{
             required,
             numeric,
        }
      }
    },
     methods: {
          GetHsnInfo(){
            
                var vm = this;
                vm.$v.$touch();  
           if (!vm.$v.$invalid){  
           var params = new URLSearchParams();
             params.append('HSN', this.HSN);
             axios.get('SaskHealthApi/Host/GetHsnInq', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             .then(function (response) {
                     vm.showModal = false;
                     vm.isValid = true;
                     vm.Patient = response.data;
                     vm.loadTable();
                })
            .catch(function (er) {
                console.log(er)
                vm.isValid = false;
                //vm.showModal = true;
                if (er.response) {
                    if(er.response.status === 400)
                    {
                      if( er.response.data.message.length)
                      {
                        vm.showMsg(er.response.data.message,"","HSN Search Error");

                      }
                    }
                
                    else 
                            vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                    
                }
                else 
                        vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                     

            })
          }
        },

        showMsg(msg,data,Title) {
          this.boxTwo = ''
          this.$bvModal.msgBoxOk(msg, {
          title: Title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',          
          okTitle: 'Close', 
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            

            this.boxTwo = this.msg;
            if(value)
            {
             
            }
          })
          .catch(err => {
            // An error occurred
          })
      },
        PatientExit(){
          this.showModal=false;
          if(this.succeeded){
           this.$emit('PatientNoteExit');
          
          }
        },
        loadTable(){
      
        var vm = this;
         var params = new URLSearchParams();
        params.append('HSN', this.HSN);
        params.append('Type', this.NoteType);
        params.append('Top10',false);
         axios.get('SaskHealthApi/Claims/GetPatientNotes?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
         .then(function (response) {
               vm.tableData=response.data;
              
            })
            .catch(function (er) {
                console.log(er)
            });
        },
        AddPatientNotePopup(Rowdata){
          this.UserData = Rowdata;
          this.UserData.hsn = this.HSN;
          this.UserData.serviceid = this.NoteType;
          this.showEditModal=true;
          this.Button = "Add";
         
       },
       EditPatientNotePopup(Rowdata){
          this.UserData = Rowdata;          
            this.showEditModal=true;
             this.Button = "Edit";
       },
        closeModal() { 
        this.showEditModal = false;
        this.loadTable();
      },
      disableSearch(){
        this.tableData = [];
         this.isValid = false;
      }  
    }
}
</script>

<style>

</style>
